// FormikPersist -> https://www.lightpohl.me/blog/persist-formik-state-on-refresh-with-react-hooks
import { useFormikContext } from "formik";
import useDebounce from "hooks/useDebounce";
import useLocalStorage from "hooks/useLocalStorage";
import React, { useEffect } from "react";
import isEqual from "react-fast-compare";

interface FormikPersistProps {
  formKey: string;
}

const FormikPersist: React.FC<FormikPersistProps> = ({ formKey }) => {
  const { values, setValues, initialValues } = useFormikContext();
  const [persistedValues, setLocalStorage] = useLocalStorage(
    formKey,
    initialValues
  );
  const debouncedValues = useDebounce(values, 300);

  useEffect(() => {
    if (persistedValues) {
      setValues(persistedValues);
    }
  }, []);

  useEffect(() => {
    if (!isEqual(persistedValues, debouncedValues)) {
      setLocalStorage(debouncedValues);
    }
  }, [debouncedValues, persistedValues, setLocalStorage]);

  return null;
};

export default FormikPersist;
